'use client'

import { Controller, useFormContext } from 'react-hook-form'
import type { FormSelectInputProps, FormType } from '../../types'
import { SelectContent, SelectItem, SelectRoot, SelectTrigger, SelectValueText } from '../../../components'

import { FormField } from '../FormField/FormField'
import { Flex, HStack, Select, SelectContext, Text } from '@chakra-ui/react'

export const FormSelectInput = <T extends FormType>({
	name,
	label,
	collection,
	helperText,
	optionalText,
	isRequired,
	placeholder,
	_formField,
	...rest
}: FormSelectInputProps<T>) => {
	const { control, formState } = useFormContext<T>()

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={isRequired}
			{..._formField}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<SelectRoot
						collection={collection}
						disabled={formState.isSubmitting}
						name={field.name}
						value={field.value as string[] | undefined}
						onInteractOutside={() => field.onBlur()}
						onValueChange={({ value }) => field.onChange(value)}
						{...rest}
					>
						<SelectTrigger>
							<SelectValueText placeholder={placeholder} />
						</SelectTrigger>
						<SelectContent>
							{collection.items.map((item) => (
								<SelectItem key={item.value} item={item} px={0} py={1}>
									<SelectContext>
										{(select) => {
											const isSelected = (select.selectedItems as { value?: string }[])
												.find((selectItem) => selectItem?.value === item.value)
											return <Flex gap={5} justifyContent={'space-between'} w='full' bg={isSelected ? 'gray.100' : 'transparent'} p={1}>
													<Text pl={2}>{item.label}</Text>
													<Text pr={2}>{isSelected ? 'Selected' : null}</Text>
												</Flex>
										}}
									</SelectContext>
								</SelectItem>
							))}
						</SelectContent>
					</SelectRoot>
				)}
			/>
		</FormField>
	)
}
